import { Component, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router) {
  }
  ngOnInit() {
  }

}




// WEBPACK FOOTER //
// A:/CM/links-ui/cm-ui-app-links/src/app/app.component.ts